module.exports = __webpack_public_path__ + "img/Dictateur.d00b0ef2.png";